import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Building2, CarFront, Home, Layers3, Sparkles, SunMedium } from 'lucide-react';
import './SampleOneHome.css';

const heroImage = 'https://images.unsplash.com/photo-1701691535820-5b041a0c6991?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBob3VzZSUyMG1pbmltYWwlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzc1NjU2MDcwfDA&ixlib=rb-4.1.0&q=85';
const supportImage = 'https://images.unsplash.com/photo-1714974528683-8940bd8311aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxmaW5hbmNpYWwlMjBjb25zdWx0aW5nJTIwbWVldGluZ3xlbnwwfHx8fDE3NzU2NTYwNzF8MA&ixlib=rb-4.1.0&q=85';
const solarImage = 'https://images.unsplash.com/photo-1771479755134-9c1e3143c110?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHw0fHxzb2xhciUyMHBhbmVscyUyMHJvb2YlMjBtb2Rlcm58ZW58MHx8fHwxNzc1NjU2MDcwfDA&ixlib=rb-4.1.0&q=85';
const AUTO_CREDIT_FORM_URL = 'https://form.jotform.com/251332360319045';

const primaryServices = [
  {
    title: 'Crédito Auto',
    description: 'Uma rota elegante para pré-análise, atendimento e conversão com alto nível de confiança.',
    href: AUTO_CREDIT_FORM_URL,
    external: true,
    icon: CarFront,
  },
  {
    title: 'Imóveis',
    description: 'Compra de casa com atendimento humano, organização visual e suporte consultivo de ponta a ponta.',
    href: '/questionario-casas',
    icon: Home,
  },
  {
    title: 'Reforma & Solar',
    description: 'Do planejamento ao orçamento, com experiência mais acolhedora, premium e clara para o cliente.',
    href: '/questionario-casas',
    icon: SunMedium,
  },
  {
    title: 'PropTech',
    description: 'Editor 2D, geração com IA e render 3D apresentados com uma linguagem visual mais sofisticada.',
    href: '/desenhar-planta',
    icon: Layers3,
  },
];

const trustPoints = [
  {
    title: 'Atendimento humano real',
    description: 'Uma estética mais premium para reforçar confiança institucional e proximidade.',
  },
  {
    title: 'Sofisticação sem ruído',
    description: 'Mais respiro, menos poluição visual e uma leitura muito mais elegante.',
  },
  {
    title: 'Tecnologia mais refinada',
    description: 'A mesma base funcional em uma apresentação muito mais premium e memorável.',
  },
];

const proptechTools = [
  {
    title: 'Editor de Planta',
    description: 'Planejamento manual com experiência visual leve e premium.',
    href: '/desenhar-planta',
  },
  {
    title: 'Gerar com IA',
    description: 'Criação de planta com linguagem mais aspiracional e humana.',
    href: '/gerar-planta',
  },
  {
    title: 'Render 3D',
    description: 'Uma ponte mais elegante entre ferramenta digital e apresentação comercial.',
    href: '/proptech',
  },
];

const SampleOneHome = () => {
  return (
    <div className="sample-one-page" data-testid="sample-one-page">
      <div className="sample-one-topbar">
        <div className="sample-one-shell flex flex-wrap items-center justify-between gap-4 py-4">
          <div>
            <p className="sample-one-heading text-3xl font-semibold text-[#2C302E]" data-testid="sample-one-brand-title">RH Consulting Holdings</p>
            <p className="text-sm text-[#5E6562]">Modelo 1 • Elegância Japonesa Contemporânea</p>
          </div>
          <div className="flex flex-wrap items-center gap-3">
            <Link to="/" className="sample-one-button-secondary" data-testid="sample-one-compare-sample-three-link">
              Ver Sample 3
            </Link>
            <Link to="/sample-2" className="sample-one-button-secondary" data-testid="sample-one-compare-sample-two-link">
              Ver Sample 2
            </Link>
            <Link to="/sample-1" className="sample-one-button-primary" data-testid="sample-one-current-route-button">
              Ver Sample 1
            </Link>
          </div>
        </div>
      </div>

      <main className="sample-one-shell pb-20">
        <section className="sample-one-hero">
          <div className="sample-one-hero-grid">
            <div className="sample-one-card rounded-[36px] p-8 sm:p-10">
              <div className="sample-one-chip" data-testid="sample-one-hero-chip">
                <Sparkles size={14} />
                confiança, acolhimento e sofisticação
              </div>
              <h1 className="sample-one-heading mt-8 text-5xl leading-[0.94] text-[#2C302E] sm:text-6xl" data-testid="sample-one-hero-title">
                Soluções inteligentes com estética mais humana e premium.
              </h1>
              <p className="mt-6 max-w-2xl text-lg leading-8 text-[#5E6562]" data-testid="sample-one-hero-description">
                Este Sample 1 mostra uma direção mais leve, refinada e acolhedora para a RH Consulting. O foco é elevar a confiança, melhorar a leitura e deixar a experiência com cara de consultoria premium.
              </p>

              <div className="mt-8 flex flex-wrap gap-4">
                <a href={AUTO_CREDIT_FORM_URL} target="_blank" rel="noreferrer" className="sample-one-button-primary" data-testid="sample-one-hero-auto-credit-link">
                  Análise de crédito auto <ArrowRight size={16} />
                </a>
                <Link to="/questionario-casas" className="sample-one-button-secondary" data-testid="sample-one-hero-houses-link">
                  Ver fluxo de imóveis
                </Link>
                <Link to="/desenhar-planta" className="sample-one-button-tertiary" data-testid="sample-one-hero-proptech-link">
                  Conhecer PropTech
                </Link>
              </div>

              <div className="sample-one-grid-3 mt-10">
                {trustPoints.map((point) => (
                  <div key={point.title} className="rounded-[28px] border border-[rgba(74,93,78,0.12)] bg-[rgba(255,255,255,0.72)] p-5" data-testid={`sample-one-trust-card-${point.title.toLowerCase().replace(/[^a-z0-9]+/gi, '-')}`}>
                    <h2 className="sample-one-heading text-2xl text-[#2C302E]">{point.title}</h2>
                    <p className="mt-3 text-sm leading-7 text-[#5E6562]">{point.description}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="space-y-5">
              <div className="sample-one-card sample-one-image-card">
                <img src={heroImage} alt="Arquitetura moderna minimalista" />
                <div className="sample-one-image-overlay">
                  <p className="text-xs uppercase tracking-[0.22em] text-[#4A5D4E]">Direção visual 1</p>
                  <h2 className="sample-one-heading mt-3 text-3xl text-[#2C302E]" data-testid="sample-one-hero-image-title">
                    Mais leve, mais sofisticado, mais institucional.
                  </h2>
                </div>
              </div>

              <div className="sample-one-card rounded-[32px] p-6 sm:p-7">
                <img src={supportImage} alt="Atendimento consultivo" className="h-40 w-full rounded-[24px] object-cover" />
                <h3 className="sample-one-heading mt-5 text-3xl text-[#2C302E]">Uma consultoria com presença serena.</h3>
                <p className="mt-3 text-sm leading-7 text-[#5E6562]">
                  O Sample 1 transforma a home em uma vitrine premium mais calorosa, ideal para imóveis, reforma, painel solar e crédito com abordagem humana.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="pt-10">
          <div className="flex flex-wrap items-end justify-between gap-4">
            <div>
              <p className="sample-one-chip" data-testid="sample-one-services-chip">Serviços em linguagem premium</p>
              <h2 className="sample-one-heading mt-5 text-5xl text-[#2C302E]" data-testid="sample-one-services-title">Como a experiência ficaria neste modelo</h2>
            </div>
            <Link to="/" className="sample-one-button-secondary" data-testid="sample-one-back-to-sample-three-link">
              Voltar para o Sample 3
            </Link>
          </div>

          <div className="sample-one-grid-4 mt-8">
            {primaryServices.map((service) => {
              const Icon = service.icon;
              const content = (
                <>
                  <div
                    key={`sample-one-service-icon-${service.title}`}
                    className="flex h-14 w-14 items-center justify-center rounded-full bg-[rgba(74,93,78,0.08)] text-[#4A5D4E]"
                  >
                    <Icon size={26} />
                  </div>
                  <h3 className="sample-one-heading mt-6 text-3xl text-[#2C302E]">{service.title}</h3>
                  <p className="mt-3 text-sm leading-7 text-[#5E6562]">{service.description}</p>
                  <div className="mt-6 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.12em] text-[#4A5D4E]">
                    Acessar <ArrowRight size={16} />
                  </div>
                </>
              );

              if (service.external) {
                return (
                  <a
                    key={service.title}
                    href={service.href}
                    target="_blank"
                    rel="noreferrer"
                    className="sample-one-card rounded-[30px] p-7 transition-transform duration-200 hover:-translate-y-1"
                    data-testid={`sample-one-service-card-${service.title.toLowerCase().replace(/[^a-z0-9]+/gi, '-')}`}
                  >
                    {content}
                  </a>
                );
              }

              return (
                <Link
                  key={service.title}
                  to={service.href}
                  className="sample-one-card rounded-[30px] p-7 transition-transform duration-200 hover:-translate-y-1"
                  data-testid={`sample-one-service-card-${service.title.toLowerCase().replace(/[^a-z0-9]+/gi, '-')}`}
                >
                  {content}
                </Link>
              );
            })}
          </div>
        </section>

        <section className="pt-14">
          <div className="grid gap-6 lg:grid-cols-[1.05fr_0.95fr]">
            <div className="sample-one-card rounded-[36px] p-8 sm:p-10">
              <p className="sample-one-chip" data-testid="sample-one-proptech-chip">PropTech elegante</p>
              <h2 className="sample-one-heading mt-6 text-5xl text-[#2C302E]">Tecnologia sem cara de dashboard frio.</h2>
              <p className="mt-4 max-w-2xl text-base leading-8 text-[#5E6562]">
                O diferencial deste modelo é integrar os fluxos digitais sem perder a sensação de atendimento premium. As ferramentas continuam presentes, mas com uma narrativa visual mais sofisticada e menos técnica.
              </p>
              <div className="sample-one-grid-3 mt-8">
                {proptechTools.map((tool) => (
                  <Link
                    key={tool.title}
                    to={tool.href}
                    className="rounded-[28px] border border-[rgba(74,93,78,0.12)] bg-[rgba(255,255,255,0.76)] p-6 transition-transform duration-200 hover:-translate-y-1"
                    data-testid={`sample-one-proptech-tool-${tool.title.toLowerCase().replace(/[^a-z0-9]+/gi, '-')}`}
                  >
                    <h3 className="sample-one-heading text-3xl text-[#2C302E]">{tool.title}</h3>
                    <p className="mt-3 text-sm leading-7 text-[#5E6562]">{tool.description}</p>
                  </Link>
                ))}
              </div>
            </div>

            <div className="sample-one-card rounded-[36px] p-6 sm:p-7">
              <img src={solarImage} alt="Painéis solares modernos" className="h-64 w-full rounded-[28px] object-cover" />
              <div className="mt-6">
                <p className="sample-one-chip" data-testid="sample-one-solar-chip">reforma & painel solar</p>
                <h3 className="sample-one-heading mt-4 text-4xl text-[#2C302E]">Mais acolhimento, mais clareza, mais confiança visual.</h3>
                <p className="mt-4 text-sm leading-7 text-[#5E6562]">
                  No Sample 1, essas páginas podem parecer uma extensão natural da consultoria principal — com menos frieza, menos ruído e maior sensação de suporte próximo.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="pt-14">
          <div className="sample-one-footer-cta rounded-[40px] p-8 sm:p-10" data-testid="sample-one-final-cta">
            <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
              <div className="max-w-3xl">
                <p className="sample-one-chip">comparação pronta</p>
                <h2 className="sample-one-heading mt-5 text-5xl text-[#2C302E]">Agora você pode comparar o Sample 1 com o Sample 3 no navegador.</h2>
                <p className="mt-4 text-base leading-8 text-[#5E6562]">
                  O Sample 1 entrega uma direção mais clara, terrosa e sofisticada. Se você gostar desse caminho, eu posso transformar a home principal inteira nesse estilo depois.
                </p>
              </div>
              <div className="flex flex-wrap gap-4">
                <Link to="/" className="sample-one-button-secondary" data-testid="sample-one-open-sample-three-link">
                  Abrir Sample 3
                </Link>
                <Link to="/sample-2" className="sample-one-button-secondary" data-testid="sample-one-open-sample-two-link">
                  Abrir Sample 2
                </Link>
                <Link to="/sample-1" className="sample-one-button-primary" data-testid="sample-one-open-sample-one-link">
                  Ficar no Sample 1
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default SampleOneHome;